import { DragLayer } from 'react-dnd';
import { branch, compose, renderNothing, toClass, withProps } from 'recompose';
import { anyPass, complement, isEmpty, isNil, pipe, prop } from 'ramda';

import { IInner, IOuter } from './DragLayer.types';

export const enhance = compose<IInner, IOuter>(
  DragLayer((monitor) => {
    const dragResult = monitor.getItem();

    return {
      items: dragResult && dragResult.draggingItems,
      itemType: monitor.getItemType(),
      currentOffset: monitor.getClientOffset(),
      isDragging: monitor.isDragging(),
    };
  }),
  toClass,
  branch(complement(prop('isDragging')), renderNothing),
  branch(pipe(prop('items'), anyPass([isNil, isEmpty])), renderNothing),
  withProps(({ items, currentOffset }) => {
    const offset = currentOffset && {
      x: currentOffset.x - 75,
      y: currentOffset.y - 30,
    };

    return {
      firstItem: items[0],
      itemsCount: items.length,
      itemStyles: offset ? { transform: `translate(${offset.x}px, ${offset.y}px)` } : { display: 'none' },
      itemBackgroundStyles: offset
        ? { transform: `translate(${offset.x - 2}px, ${offset.y - 2}px)` }
        : { display: 'none' },
    };
  }),
);
